import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './index.css'
import AppRoot from './App'
import LandingPage from './pages/LandingPage'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import { supabase } from './lib/supabase'

function SmartRoot() {
  const isPWA = window.matchMedia('(display-mode: standalone)').matches
  const [checking, setChecking] = useState(true)
  const [hasSession, setHasSession] = useState(false)

  useEffect(() => {
    if (isPWA) { setChecking(false); return }
    supabase.auth.getSession().then(({ data: { session } }) => {
      setHasSession(!!session)
      setChecking(false)
    })
  }, [isPWA])

  if (isPWA) return <Navigate to="/app" replace />
  if (checking) return null
  if (hasSession) return <Navigate to="/app" replace />
  return <LandingPage />
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/"        element={<SmartRoot />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms"   element={<TermsOfService />} />
        <Route path="/app"     element={<AppRoot />} />
        <Route path="/app/*"   element={<AppRoot />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)
